import React from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '../../common/modal'
import Button from '../../elements/Button'
import InCartItem from './InCartItem'

const FoodInCartModalComp = ({
    show,
    handleClose,
    handleAddNew,
    foods,
    handleUpdateAmount,
    handleEditFood,
}) => {
    const { t } = useTranslation()
    const foodName =
        foods[0]?.foodData?.name ||
        foods[0]?.foodParent?.name ||
        foods[0]?.name ||
        ''

    return (
        <Modal className="food-in-cart-modal" isOpen={!!show}>
            <div className="container-fluid container-xl food-in-cart">
                <div className="food-in-cart__name flex-between">
                    <div>{foodName}</div>
                </div>

                <div className="food-in-cart__list">
                    {foods.map((f, index) => (
                        <InCartItem
                            handleUpdateAmount={handleUpdateAmount}
                            handleEditFood={() => handleEditFood(f.foodData)}
                            food={f}
                            key={index}
                        />
                    ))}
                </div>

                <div className="wrap-new-food">
                    <Button fullWidth onClick={handleAddNew}>
                        {t('modalFastEditMobile.btnAddOther')}
                    </Button>
                    <Button fullWidth onClick={handleClose}>
                        {t('modalFastEditMobile.btnOK')}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default FoodInCartModalComp
